<template>
  <div>
    <back-btn />
    <v-container fluid>
      <v-row justify="center">
        <v-col lg="8">
          <v-card class="card--shadow pa-2">
            <v-card-text>
              <v-row>
                <v-col class="col--padding" lg="3">
                  <label>Month <require-sign /></label>
                  <v-select
                    class="mr-1"
                    :items="export_months"
                    v-model="month"
                    item-text="text"
                    :error-messages="handleFieldErrors($v.month)"
                    item-value="value"
                    dense
                    outlined
                  ></v-select>
                </v-col>
                <v-col class="col--padding" lg="3">
                  <label>Year <require-sign /></label>
                  <v-select
                    class="mr-1"
                    :items="years"
                    v-model="year"
                    item-text="text"
                    item-value="value"
                    :error-messages="handleFieldErrors($v.year)"
                    dense
                    outlined
                  ></v-select>
                </v-col>
                <v-col class="col--padding" lg="3">
                  <label>Filter By <require-sign /></label>
                  <v-select
                    class="mr-1"
                    :items="[
                      { value: '1', text: 'Township Group' },
                      { value: '2', text: 'Township' },
                    ]"
                    v-model="filterby"
                    item-text="text"
                    item-value="value"
                    :error-messages="handleFieldErrors($v.filterby)"
                    dense
                    outlined></v-select>
                </v-col>
                <v-col class="col--padding" lg="3" v-if="filterby == '1'">
                  <label>Township Group <require-sign /></label>
                  <v-select
                    class="mr-3"
                    v-model="township_group_id"
                    placeholder="choose township group..."
                    :error-messages="handleFieldErrors($v.township_group_id)"
                    hide-details
                    outlined
                    dense
                    item-text="name"
                    item-value="id"
                    :items="townshipGroups"
                  >
                  </v-select>
                </v-col>
                <v-col class="col--padding" lg="3" v-if="filterby == '2'">
                  <label>Townships <require-sign /></label>
                  <v-select
                    class="mr-3"
                    v-model="township_id"
                    placeholder="choose township..."
                    :error-messages="handleFieldErrors($v.township_id)"
                    hide-details
                    outlined
                    dense
                    item-text="name"
                    item-value="id"
                    :items="townships"
                    
                  >
                  </v-select>
                </v-col>
                
              </v-row>
              <v-row justify="center">
                <v-col class="col--padding" lg="3">
                  <div>
                    <v-btn
                      height="40"
                      color="purple accent-4"
                      @click.prevent="viewMontlyList"
                      outlined
                      rounded
                      dark
                    >
                      view report
                      <v-icon right>mdi-arrow-right-thick</v-icon>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions></v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { required , between} from "vuelidate/lib/validators";
import { ValidationMixin } from "./../../mixins/ValidationMixin";
import { mapState } from "vuex";
import BackBtn from "@/components/navigation/BackBtn.vue";
import RequireSign from "@/components/notification/RequireSign.vue";
export default {
  components: { BackBtn ,RequireSign},
  mixins: [ValidationMixin],
  data: () => ({
    month: null,
    year: null,
    township_id: null,
    township_group_id: null,
    filterby:null,
  }),
  validations: {
    month: {
      required,
    },
    year: {
      required,
    },
    filterby:{
      required,
    },
    township_id: { between: between(0, 99) },
    township_group_id: { between: between(0, 99) },
  //   township_id: { 
  //     required: function() {
  //     return this.township_group_id !== null;
  //   }
  //    },
     
  //  township_group_id: {
  //     required: function() {
  //       return this.township_id !== null;
  //     }
  //   },
  },
  methods: {
    viewMontlyList() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$router.push({
          name: "monthly-list-report",
          query: {
              month: this.month,
              year: this.year,
              filterby: this.filterby,
              township_id: this.filterby === '2' ? this.township_id : null,
              township_group_id: this.filterby === '1' ? this.township_group_id : null,
              township_name: this.filterby === '2' 
                        ? this.townships.find(
                    (twn) => twn.id === this.township_id
                  ).name
                  : this.filterby ==='1'
                  ? this.townshipGroups.find(
                    (twn) => twn.id === this.township_group_id
                  ).name
                  :null
          },
        });
      }
    },
    
  },
  computed: {
    ...mapState("InitialData", ["export_months", "years"]),
    ...mapState("Township", ["townships"]),
    ...mapState("TownshipGroup", ["townshipGroups"]),
  },
  created() {
    this.$store.dispatch("Township/getTownships");
    this.$store.dispatch("TownshipGroup/getTownshipGroups");
  },
};
</script>
